import { ZEntity } from "src/types/ZEntity";
import { ZUid } from "src/types/zUid";
import { ZMc2Settings } from "../../../Mc2Types";
import { ZMc2TableRow } from "../Mc2EntityTypes";

export type Mc2PointRow = {
  id: ZUid;
  name: string;
  description: string;
};

export const cvtEntities = (
  srcList: ZEntity[] | undefined,
  settings: ZMc2Settings,
): Mc2PointRow[] => {
  if (!srcList) return [];
  const { pointAttrNameId, pointAttrDescriptionId } = settings;
  return srcList.map(({ id, attributeValues }) => ({
    id,
    name: getStr(pointAttrNameId, attributeValues),
    description: getStr(pointAttrDescriptionId, attributeValues),
  }));
};

const getStr = (
  needAttrId: ZUid | null | undefined,
  attributeValues: ZEntity["attributeValues"],
): string =>
  attributeValues.find(({ attributeId }) => needAttrId === attributeId)
    ?.values?.[0] ?? "";

export const cvtMc2PointRowToTableRow = (
  mcEntityId: ZUid,
  header: string[],
  src?: Mc2PointRow,
): Omit<ZMc2TableRow, "id"> => ({
  mcEntityV2Id: mcEntityId,
  point: src?.name ?? "",
  dictionaryPointId: src ? src.id : null,
  fromDictionary: !!src,
  description: src?.description ?? "",
  criticality: false,
  scaleMinus: 0,
  scalePlus: 0,
  tolMinus: 0,
  tolPlus: 0,
  sizes: header.reduce(
    (acc, size, index) => ({
      ...acc,
      [size]: {
        value: 0,
        position: index,
      },
    }),
    {} as ZMc2TableRow["sizes"],
  ),
});
